<template lang="pug">
  v-row
    v-col(cols=12)
      h2.mb-2
        span(v-if="!task") Ответы
        span(v-else) {{ task.title }}

      template(v-if="task")
        p {{ task.description }}
    v-col(cols=12)
      v-skeleton-loader(
        v-if="loading.init"
        type="card@5"
      )
      div(v-else)
        v-card(
          v-for="unit in task.task_units"
          :key="unit.id"
        ).sdo-card.mb-4.pa-3
          v-card-title {{ unit.title }}
          v-card-text
            span {{ unit.description }}
            task-unit-type-wrap(
              :task-unit="unit"
              #default="{ component }"
            )
              component(
                :is="component"
                :task="task"
                :value="unit"
                analytic
              )
</template>

<script>
import TaskUnitTypeWrap from '@/modules/Groups/components/TaskUnitTypeWrap.vue';

export default {
  components: {
    TaskUnitTypeWrap,
  },
  data: () => ({
    loading: {
      init: true,
    },
    task: null,
  }),
  computed: {
    taskId() {
      return this.$route.params.id;
    },
  },
  created() {
    this.fetchTask();
  },
  methods: {
    async fetchTask() {
      this.loading.init = true;
      const resp = await this.$api.tasks.tasksStatisticsShow(this.taskId);
      this.task = resp.data.data;
      this.loading.init = false;
    },
  },
};
</script>
